import { useSelector } from 'react-redux';
import { RootState } from '@nxsys/store';

const REVERSE_PAYROLL_PERMISSION = 'COMPANY.SELFBILLS_PAYSLIPS.DELETE';

export const useCanReversePayroll = (): boolean => {
  const permissions = useSelector(
    (state: RootState) => state.appStore.permissions,
  );
  return permissions?.includes(REVERSE_PAYROLL_PERMISSION) ?? false;
};
